// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tm-0";